<template>
  <div v-if="active" class="modal is-active">
    <div class="modal-background"></div>
    <aside class="modal-card is-flex" qa="personalize-modal">
      <span v-if="!isSigningUp && !isCreate" class="close cursor-pointer" @click="close"><i class="fal fa-times"></i></span>
      <header class="title">
        <h2 class="signed-up-header"> {{ $t('filterModal.filters') }}</h2>
      </header>
      <section class="categories-container" :class="{'is-signingup' : user && isSigningUp, 'has-tooltips': isCreate}">
        <div v-for="(group) in filter.filterGroups" :key="group.name" class="category">
          <div class="is-flex a-category unselectable" :class="{'disabled': ($isYSC || $isAjas) && selectedCategories.length >=1 && !isCategoryStarred(category) && isCreate, 'a-category-ajas' : $isAjas}">
            <span class="cursor-pointer is-flex" :disabled="selectedCategories.length === 1 && isCreate">
              <div class="category-title" :class="{'is-collapsed': !true}">
                 {{ $t('filterModal.' + group.name).toUpperCase() }}
              </div>
            </span>
          </div>
          <div class="is-flex subcategories-container">
            <div class="subcategory cursor-pointer unselectable" :class="{'selected': isTagSelected(tag)}" v-for="tag in group.tags" :key="tag.id" @click="clickTag(tag, group)">
              {{ tag.name }}
            </div>
          </div>
        </div>
      </section>
      <footer class="is-flex button-container" :class="{'is-signingup' : user && isSigningUp}">
        <span class="is-flex is-pulled-left">
          <button class="ml-2 button is-white cursor-pointer" @click="clearAllTags" :disabled="selectedTags.length === 0"> {{ $t('filterModal.clear') }} </button>
        </span>
        <div v-if="isLoggedIn" class="is-flex is-pulled-left">
          <input type="checkbox" class="remember" v-model="rememberTags">{{ $t('filterModal.rememberSetting') }}
        </div>
        <button type="submit" class="button is-primary mr-5 gtm-login-signup" :class="{'is-ios-android': isIosOrAndroid}" @click="setTagFilter"> {{ $t('category.apply') }} </button>
      </footer>
      <div class="modal" :class="{'is-active': showLoadingModal}">
        <div class="modal-background"></div>
        <div class="modal-content">
          <button v-if="hasLoadingError" @click="forceClose" class="delete close-button" aria-label="close"></button>
          <span v-else class="loader"></span>
          <div class="text">{{ loadingMessage }}</div>
        </div>
      </div>
    </aside>
  </div>
</template>

<script>
import CategoryStar from '@/components/Controls/CategoryStar'

import breakpoints from '@/libs/breakpoints'
import userAgent from '@/libs/user-agent'
import Checkbox from '@/components/Controls/Checkbox'

import auth from '@/mixins/auth'
import componentState from '@/mixins/component-state'

export default {
  data: function () {
    return {
      active: false,
      selectedCategories: [],
      starredCategories: [],
      isSigningUp: false,
      categoriesChanged: false,
      tagsChanged: false,
      redirectToHome: false,
      showLoadingModal: false,
      hasLoadingError: false,
      expandedCategories: [],
      displayingToolTip: false,
      filter: {},
      selectedTags: [],
      rememberTags: true
    }
  },
  props: ['isNavBar', 'isCreate'],
  components: { CategoryStar, Checkbox },
  mixins: [componentState, auth],
  computed: {
    isIosOrAndroid: userAgent.isIOS || userAgent.isAndroid,
    isIOS: userAgent.isIOS,
    categories: function () {
      return this.$store.getters.categoriesLoaded ? this.$store.getters.sortedProjectCategories(true, true) : []
    },
    user: function () {
      return this.$store.getters.currentUser
    },
    loadingMessage: function () {
      return this.hasLoadingError ? 'Looks like something went wrong. Please close and try again' : 'Loading your categories...'
    },
    allExpanded: function () {
      return this.expandedCategories.length === this.categories.length
    },
    minCategories: function () {
      return 1
    },
    isMobile: function () {
      return breakpoints.isMobile()
    },
    showAllOption: function () {
      return !this.$isYSC && !this.$isAjas
    },
    buttonText: function () {
      if (this.$store.getters.userFilterTags.tags && this.$store.getters.userFilterTags.tags.length > 0) {
        return 'Filter Active'
      }
      return this.$t('explore.filterRemember')
    }
  },
  watch: {
    active: function (active) {
      // if (active) {
      //   this.getFilterOptions()
      // }
      active ? this._callback('lockScrolling', false) : this._callback('unlockScrolling', true)
      if (this.$store.getters.modalIsVisible('category') && !this.$store.getters.modalIsVisible('login')) {
        this.isDispatched = true
      }
    }
  },
  mounted: function () {
    this.getFilterOptions()
    this.rememberTags = this.$store.getters.userFilterTagsRemember.remember
  },
  methods: {
    showModal: function (source) {
      this.active = true
      this.signupSource = source
    },
    getFiltersIfExist: function () {
      this.$store.dispatch('getFilterTags', { username: this.user.userName }).then((response) => {
        // this.rememberTags = this.$store.getters.userFilterTagsRemember
        this.rememberTags = response.remember
        if (this.$store.getters.userFilterTagsRemember.remember) {
          this.selectedTags = response.tagIDs
        }
      }, (error) => {
        this.error = error.message
      })
    },
    getFilterOptions: function () {
      this.$store.dispatch('getFilterOptions').then(() => {
        if (this.$store.getters.filterOptions[0]) {
          this.filter = this.$store.getters.filterOptions[0]
          this.getFiltersIfExist()
        }
      }, (error) => {
        this.error = error.message
      })
    },
    setTagFilter: function () {
      const data = {
        username: this.isLoggedIn ? this.user.userName : '',
        tags: this.selectedTags,
        remember: this.rememberTags
      }
      this.$store.dispatch('setUserFilter', data).then(() => {
        this.categoriesChanged = true
        this.tagsChanged = true
        this.done()
      }, (error) => {
        this.error = error.message
      })
    },
    selectedCategoryIndex: function (category) {
      return this.selectedCategories.indexOf(category.id)
    },
    isCategorySelected: function (category) {
      return this.selectedCategoryIndex(category) !== -1
    },
    isTagSelected: function (tag) {
      return this.selectedTags.includes(tag.id)
    },
    expandedCategoryIndex: function (category) {
      return this.expandedCategories.indexOf(category.id)
    },
    isCategoryExpanded: function (category) {
      return this.expandedCategoryIndex(category) !== -1
    },
    starredCategoryIndex: function (category) {
      return this.starredCategories.indexOf(category.id)
    },
    isCategoryStarred: function (category) {
      return this.starredCategories.indexOf(category.id) !== -1
    },
    hasSubCategories: function (category) {
      return category.subCategories && category.subCategories.length > 0
    },
    clickTag: function (tag, group) {
      // Find the other tags within the same group
      const excludedTagIds = this.filter?.filterGroups?.find(m => m.name === group.name)?.tags?.filter(m => m.id !== tag.id).map(m => m.id)
      if (this.selectedTags.includes(tag.id)) {
        const index = this.selectedTags.indexOf(tag.id)
        if (index > -1) {
          this.selectedTags.splice(index, 1)
        }
      } else {
        if (excludedTagIds) {
          this.selectedTags = this.selectedTags.filter(m => !excludedTagIds.includes(m))
        }
        this.selectedTags.push(tag.id)
      }
    },
    updateExpandCategory: function (category) {
      if (!this.isCategoryExpanded(category)) {
        this.expandedCategories.push(category.id)
      } else {
        this.expandedCategories.splice(this.expandedCategoryIndex(category), 1)
      }
    },
    clearAllCategories: function () {
      this.selectedCategories = []
      this.starredCategories = []
    },
    clearAllTags: function () {
      this.selectedTags = []
      this.rememberTags = false
      this.$store.dispatch('resetUserFilter')
    },
    resetTags: function () {
      if (!this.rememberTags) {
        this.selectedTags = []
      }
    },
    updateAllExpanded: function () {
      if (this.allExpanded) {
        this.expandedCategories = []
      } else {
        this.categories.forEach((category) => {
          if (!this.isCategoryExpanded(category)) {
            this.expandedCategories.push(category.id)
          }
        })
      }
    },
    done: function () {
      this.close()
      this.$emit('categoriesChanged', this.categoriesChanged)
    },
    refreshKey: function () {
      return (Math.random() + 1).toString(36).substring(7)
    },
    close: function () {
      this.active = false
      this.$emit('modalDone', true, true)
    },
    forceClose: function () {
      this.close()
    },
    dataBalloonPos: function (index) {
      let pos = 'up'
      if (index < this.categories.length / 2) {
        pos = 'down'
      }
      if (this.isMobile) {
        pos = pos + '-right'
      }
      return pos
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';

  $border-color: #DCDCDC;
  $modal-body-color: #F2F2F2;

  input.remember {
    margin: 4px 3px 0 0;
    width: 0.95rem;
    height: 0.95rem;
  }
  .close {
    font-size: 1.3rem;
    background-color: transparent;
    opacity: 0.75;
    position: absolute;
    right: 1rem;
    top: 0.5rem;
    border: none;
  }

  .ysc-modal-card {
    background: white !important;
    max-height: 700px !important;
    max-width: 640px !important;
    overflow-x: hidden;
    @include mobile-and-ipad {
      overflow: visible;
    }
  }

  .modal-card {
    overflow-y: hidden;
    overflow: auto;
    background: $modal-body-color;
    flex-direction: column;
    justify-content: space-between;
    max-width: 620px;
    width: 98vw;
    max-height: 640px;
    height: calc(100vh - 20px);
    @include mobile {
      max-height: 80%;
    }
    img {
      display: block;
    }
  }

  .category-image-container {
    min-width: 26px;
    min-height: 26px;
  }
  .category-image {
    width: 26px;
    height: 26px;
    border-radius: 50%;
    @include shadow;
  }

  // HEADER styles
  .title {
    border-bottom: 1px solid $border-color;
    margin-bottom: 0 !important;
    text-align: center;
    h2 {
      font-family: $primary-font;
      font-weight: $primary-font-weight;
      font-size: 1.4rem;
    }
    .signed-up-header {
      padding: 1.8rem 0 1.2rem;
      @include mobile {
        font-size: 1.2rem;
        padding: 1.5rem 0 1rem;
        .mobile-line-break {
          display: block;
          padding-top: 2px;
        }
      }
    }
    .not-signed-up-header {
      padding: 1rem 0 0.3rem;
      .username {
        font-weight: 700;
      }
    }
    .welcome-sub {
      font-size: 0.9rem;
      font-weight: 300;
      padding: 0 1.5rem 0.9rem;
      @include mobile {
        font-size: 0.8rem;
      }
    }
  }

  .loader {
    display: block;
    font-size: 2rem;
    margin: 1rem auto;
  }

  .categories-container {
    overflow-y: scroll;
    overflow-x: hidden;
    margin-top: 1rem;
    &.has-tooltips {
      overflow: visible
    }
  }

  .category {
    width: 72.5%;
    margin: auto;
    margin-bottom: 1rem;
    @include mobile {
      width: 80%;
    }
  }

  .a-category {
    margin-top: 1.25rem;
  }

  .a-category-ajas {
    margin-top: 0.35rem;
  }

  .category-title {
    font-weight: 700;
    margin: 0 0 1.25rem 0.5rem;
    &.is-collapsed {
      margin-bottom: 0.75rem;
    }
  }

  .subcategories-container {
    margin-left: 2rem;
    justify-content: flex-start;
    flex-wrap: wrap;
  }

  .subcategory{
    display: flex;
    justify-content: center;
    align-content: center;
    flex-direction: column;
    font-size: 0.8rem;
    background-color: white;
    margin-right: 0.5rem;
    margin-bottom: 0.5rem;
    padding: 0.25rem 0.75rem;
    border: 1px solid transparent;
    &.selected {
      background-color: $modal-body-color;
      border-color: black;
    }
  }

  .select-all {
    text-decoration: underline;
    margin-left: 0.5rem;
    font-size: 0.91rem;
  }

  // FOOTER styles
  .button-container {
    width: 100%;
    align-items: center;
    justify-content: space-between;
    padding: 0.75rem 0;
    background-color: white;
    border: 1px solid darkgrey;
    border-style: none;
    border-top-style: solid;
    @include mobile {
      padding-left: 1rem;
      min-height: 50px;
    }
  }
  .button {
    border-radius: 0;
    height: auto;
    padding: 0.5rem 1.4rem;
    font-size: 0.85rem;
    background: $primary;
    border: 0;
    color: #fff;
    text-transform: uppercase;
    @include mobile {
      padding: 0.5rem 0.75rem;
    }
  }
  .loader {
    display: block;
    font-size: 2rem;
    margin: 1rem auto;
  }
  .tooltip-icon {
    font-size: 0.75rem;
  }

  .checkbox-container {
    flex-direction: column;
    position: relative;
    padding-left: 20px;
    padding-right: 10px;
    user-select: none;
    &:not(:nth-of-type(3)) {
      padding-bottom: 1rem;
    }
    label {
      font-size: .8rem;
      display: inline;
      position: relative;
    }
    .checkbox-wrapper {
      padding: 10px 0;
      flex-wrap: wrap;
    }
    .checkmark {
      position: absolute;
      top: 5px;
      left: -30px;
      height: 20px;
      width: 20px;
      background-color: #FFFFFF;
      border: 1.5px solid #8b8b8b;
      transition: 0.1s;
      i {
        display: none;
        color: white;
        margin-left: 3px;
        margin-top: 2.1px;
      }
      &:hover {
        transition: 0.1s;
        background-color: #e9e9e9;
      }
      &:after {
        content: '';
        position: absolute;
        display: none;
      }
    }
    input:checked ~ .checkmark {
      i {
        display: block;
      }
      background-color: $primary;
    }
    input:checked ~ .checkmark:after {
      display: block;
    }
  }

  //Disable Styles
  .disabled {
    cursor: not-allowed;
    border: none !important;
    opacity: .2;
    z-index: 1;
  }
</style>
